<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>{{ $t('farm.farms') }}</h2>
        <v-spacer></v-spacer>

        <v-btn color="primary" dark @click="$router.push({ name: 'FarmRegistartion' })">
          {{ $t('farm.registerAfarm') }}
        </v-btn>
      </div>

  

      <v-card elevation="0" class="px-5">
        <v-card-text>
          <v-data-table :headers="tableHeaders" :items="items" item-key="farmNumber"
            :items-per-page="tableOptions.itemsPerPage" :loading="loading" loading-text="Loading Farms... Please wait"
            :footer-props="{
              'items-per-page-options': itemsPerPageOptions,
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Farms per page',
            }" :options.sync="tableOptions" :server-items-length="totalfarms" hide-default-footer :header-props="{
  'sort-icon': 'mdi-unfold-more-horizontal'
}">

    
            <!-- <template v-slot:[`header.farmNumber`]="{ header }">
              <div class="d-flex flex-row">{{ header.text }}</div>
            </template> -->

            <!-- <template
              v-slot:header="{ props: { headers } }"
            >
              {{headers}}
            </template> -->

            <!-- <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr class="table-header">
                  <th 
                      v-for="item in headers" 
                      :key="item.value"
                      class="table-header-span"
                  >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td>
                    <div class="d-flex flex-row">
                      {{ item.text }}
                      <v-icon small>mdi-arrow-up</v-icon>
                    </div>
                  </th>
                </tr>  
              </thead>
            </template> -->

            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px" :placeholder="$t('farm.searchState')"
                  dense v-model="search" @click:append="searchFarms" @input="resetSearchOnEmpty"
                  class="shrink"></v-text-field>
                <!-- <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchFarms"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn> -->
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalfarms }}
                </div>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)">
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)">
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                      <v-icon dark> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>

                  <v-card width="600">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('farm.customization') }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t('farm.recordsPerpage') }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3" step="1"
                            ticks="always" tick-size="4"></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                            <v-checkbox v-model="selectedHeaders" :label="header.text" color="primary"
                              :value="header.text" hide-details :disabled="
                                header.text == 'Actions' || header.value == 'owner' || header.value == 'name'
                              "></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>

                        <v-btn outlined color="primary" @click="resetDefaut" width="fit-content">
                          {{ $t('farm.restoreDefault') }}
                        </v-btn>
                        <v-btn color="primary" @click="resetTableStructure" width="190">
                          {{ $t('farm.apply') }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear color="primary" :height="8" indeterminate></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" 
                  style="position: relative; width: 0; height: 0">
                  <!-- <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td> -->

                  <template v-for="h in tableHeaders">
                    <td :key="h.value" v-if="h.value == 'owner'">
                      {{ item[h.value] && item[h.value].name ? item[h.value].name : item.ownerId }}
                    </td>
                    <td :key="h.value" v-else-if="h.value == 'name'" style="max-width: 150px;">
                      {{ item[h.value] }}
                    </td>
                    <td :key="h.value" v-else-if="h.text == 'Actions'" style="max-width: 150px;">
                      <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            fab
                            v-bind="attrs"
                            v-on="on"
                            class="green-shadow"
                            @click="editFarm(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("farm.editFarm") }}</span>
                      </v-tooltip>
                      <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            fab
                            v-bind="attrs"
                            v-on="on"
                            class="green-shadow ml-4"
                            @click="viewFarm(item)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("farm.viewFarm") }}</span>
                      </v-tooltip>
                    </td>
                    <td :key="h.value" v-else>
                      {{ item[h.value] }}
                    </td>
                  </template>


                  <!-- <td>{{ item.farmNumber }}</td>
                  <td>{{ item.govRegistrationNo }}</td>
                  <td>{{ item.cooperativeID }}</td>
                  <td>{{ item.owner.name }}</td>
                  <td>{{ item.farmType }}</td>
                  <td>{{ item.contractMating }}</td> -->
                  <div style="position: absolute; right: 10px; top: 4px" v-if="item === selectedItem">
                    <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        fab
                        v-bind="attrs"
                        v-on="on"
                        :to="({name: 'SingleFarm', params: { id: item.farmNumber }})"
                      >
                        <v-icon>mdi-dots-horizontal</v-icon></v-btn
                      >
                    </template>
                    <span>More Details</span>
                  </v-tooltip> -->
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          fab
                          v-bind="attrs"
                          v-on="on"
                          class="ml-1"
                          :to="{
                            name: 'EditFarm',
                            params: { id: item.farmNumber },
                          }"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip> -->
                  </div>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from 'graphql-tag'
import Breadcrumb from "@/components/core/Breadcrumb";

export default {
  apollo: {
  allUserFarms: {
      query: gql`
      query GetUserFarms($page: Int!, $limit: Int!, $searchPhrase: String!, $sortCol: String!, $sortOrder: String!) {
        allUserFarms(searchUserFarmInput: {
          page: $page,
          limit: $limit,
          searchPhrase: $searchPhrase,
          sortCol: $sortCol,
          sortOrder: $sortOrder,
        }) {
          count
          fetchedRows
          rows {
          id
          farmName
          registrationNo
          lat
          log
          address
          area
          areaUomId
          parameter
          parameterUomId
          farmOwnershipType
          farmType
          productionSystem
          farmOwner
          userId
          country
          state
          city
          govRegistrationNum
          contractMating
          cooperativeId
          cooperativeName
          licenceNum
          licenceExpiryDate
          regulatorName
          houseNum
          street
          regulatorRepresentiveName
          isDeleted
          farmingActivity
          farmNumber
          communityName
          FarmCoordinates {
            id
            lat
            log
          }
          GeoFences {
            id
            geofenceName
            geofenceArea
            geofenceAreaUOMId
            geofenceParameter
            geofenceCoordinates {
            id
            lat
            log
            }
          }
          farmTypeAssoc {
            id
            name
          }
          userAssoc {
            id
          }
          productionSystemAssoc {
            id
            name
          }
          createdAt
          }
        }
        }
      `,
      variables() {
        return {
        page: this.tableOptions.page,
        limit: this.tableOptions.itemsPerPage,
        searchPhrase: this.search,
        sortCol: "createdAt",
        sortOrder: "DESC"
        };
      },
      fetchPolicy: 'network-only',
      skip: () => true,
      result: function ({ data }) {
        if (data) {
        this.allFarms = data.allUserFarms
        this.items = data.allUserFarms.rows
        this.totalfarms = data.allUserFarms.count
        this.currentRows = data.allUserFarms.fetchedRows
        }
      },
      update: (data) => {
        return data.allUserFarms.rows;
      },
},
},
  components: {
    breadcrumb: Breadcrumb,
  },
  watch: {
    tableOptions: {
      handler() {
        this.getfarm();
      },
      deep: true,
    },
  },
  async mounted() {
    document.title = this.$t('farm.farms');
    this.selectedHeaders = this.allSelectedHeaders;


    this.tableHeaders = this.headers;

    await this.getfarm()
  },
  created() {
    
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  methods: {
    viewFarm(farmItem) {
      this.$router.push({
        name: 'SingleFarm',
        params: { id: farmItem.id},
      })
    },
    editFarm(farmItem) {
      console.log(farmItem, 'farmitem')
      this.$router.push({
        name: 'EditPrimaryFarm',
        params: { id: farmItem.id},
      })
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    searchFarms() {
      if (this.search == "") return;

        this.tableOptions.page = 1;
        this.getfarm();
      
    },
    resetSearchOnEmpty() {

        this.tableOptions.page = 1;
        this.getfarm();
      
    },
   async getfarm() {
    this.loading = true;
    
    this.$apollo.queries.allUserFarms.skip = false;
    await this.$apollo.queries.allUserFarms.refetch();

      try {


        this.items = this.allFarms.rows;
            this.currentrows = this.allFarms.fetchedRows;
            this.totalfarms = this.allFarms.count;

            if (this.totalfarms < 1) {
              this.oldSelected = this.selectedHeaders;
              this.selectedHeaders = this.noRecordHeader;
            } else {
              if (this.oldSelected.length > 1)
                this.selectedHeaders = this.oldSelected;
              else {
                this.selectedHeaders = this.allSelectedHeaders;
                this.oldSelected = [];
              }
            }
            this.resetTableStructure();


            this.pageCount = Math.ceil(
              this.totalfarms / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalfarms / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - this.allFarms.fetchedRows);
            console.log(this.totalfarms);
            this.loading = false;
  

      } catch (error) {
        this.loading = false;
      }
      
    },

    goToFarm(frmNum) {
      this.$router.push({ name: "SingleFarm", params: { id: frmNum } });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getfarm();
    },

    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];

      this.menu = false;
      // this.getfarm();
      this.stopLoading();
    },
  },
  data() {
    return {
      allFarms: {},
      menu: false,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [10, 25, 50, 100],

      to: "",
      from: "",
      totalPages: "",
      search: "",
      selected: [],
      items: [],
      totalfarms: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: {},

      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('farm.farms'),
          disabled: true,
          to: { name: "My farm" },
        },
      ],
      singleSelect: false,
      headers: [

        {
          text: this.$t('farm.farmName'),
          value: "farmName",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t('farm.farmOwner'),
          value: "farmOwner",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t('farm.farmOwnershipType'),
          value: "farmOwnershipType",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t('farm.govtRegistry'),
          value: "govRegistrationNum",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t('farm.cooperativeID'),
          value: "cooperativeId",
          class: "black--text",
          sortable: false,
        },
        { text: this.$t('farm.licenceNum'), value: "licenceNum", class: "black--text", sortable: false, },
        { text: 'Actions', class: "black--text", sortable: false, },
        // {
        //   text: this.$t('farm.contractMating'),
        //   value: "contractMating",
        //   class: "black--text",
        //   sortable: false,
        // },
      ],
      tableHeaders: [],

      selectedHeaders: [],
      oldSelected: [],
      noRecordHeader: [
        this.$t('farm.farmOwner'),
        this.$t('farm.farmName'),
        this.$t('farm.farmType'),
        this.$t('farm.contractMating'),
        this.$t('farm.govtRegistry'),
        this.$t('farm.cooperativeID'),
      ],
      allSelectedHeaders: [
        this.$t('farm.farmName'),
        this.$t('farm.farmOwner'),
        this.$t('farm.farmType'),
        this.$t('farm.farmOwnershipType'),
        this.$t('farm.govtRegistry'),
        this.$t('farm.cooperativeID'),
        this.$t('farm.licenceNum'),
        "Actions",
      ],

      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header th {
  white-space: nowrap;
}

::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.table-header {
  background: $secondary2-color;
}

.table-header-span {
  text-transform: uppercase !important;
  color: black !important;
}
</style>